export const scoreDict = {
    59: 0.1,
    60: 0.11,
    61: 0.122,
    62: 0.135,
    63: 0.15,
    64: 0.167,
    65: 0.183,
    66: 0.2,
    67: 0.217,
    68: 0.233,
    69: 0.25,
    70: 0.267,
    71: 0.283,
    72: 0.3,
    73: 0.317,
    74: 0.333,
    75: 0.35,
    76: 0.367,
    77: 0.392,
    78: 0.417,
    79: 0.442,
    80: 0.467,
    81: 0.492,
    82: 0.517,
    83: 0.550,
    84: 0.583,
    85: 0.6,
    86: 0.617,
    87: 0.65,
    88: 0.683,
    89: 0.7,
    90: 0.723,
    91: 0.761,
    92: 0.8,
    93: 0.84,
    94: 0.883,
    95: 0.9,
    96: 0.917,
    97: 0.94,
    98: 0.96,
    99: 0.983,
    100: 1,
    105: 1.25,
    110: 1.5,
    115: 1.75,
    120: 2.1
};